"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFulfillmentGroupAdjustmentsTotal = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const lodash_1 = require("lodash");
/**
 * Takes a `fulfillmentGroup` and returns an object containing the total
 * adjustments amount and currency for that group.
 *
 * @param {Object} fulfillmentGroup - A fulfillment group from a cart
 *
 * @return {{amount: number, currency: string}|{}}
 */
const calculateFulfillmentGroupAdjustmentsTotal = (fulfillmentGroup) => {
    const currency = (0, lodash_1.get)(fulfillmentGroup, 'groupFulfillmentPriceBeforeAdjustments.currency');
    // don't show this as a discount
    if (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.overrideFulfillmentPriceFlag) {
        return {
            amount: 0,
            currency
        };
    }
    const priceBeforeAdjustments = (0, lodash_1.get)(fulfillmentGroup, 'groupFulfillmentPriceBeforeAdjustments.amount', 0.0);
    const itemsSubtotal = (0, lodash_1.get)(fulfillmentGroup, 'fulfillmentItemsSubtotal.amount', 0.0);
    const totalFulfillmentPrice = handleDecimalSubtraction((0, lodash_1.get)(fulfillmentGroup, 'totalFulfillmentPrice.amount', 0.0), itemsSubtotal);
    const itemAdjustmentsTotal = (0, lodash_1.get)(fulfillmentGroup, 'fulfillmentItems', [])
        .map(fi => (0, lodash_1.get)(fi, 'fulfillmentAdjustmentsTotal.amount', 0.0))
        .reduce((sum, adjustment) => sum + adjustment, 0.0);
    if (totalFulfillmentPrice >= priceBeforeAdjustments &&
        itemAdjustmentsTotal === 0.0) {
        return {
            amount: 0,
            currency
        };
    }
    const groupAdjustmentsTotal = handleDecimalSubtraction(priceBeforeAdjustments, totalFulfillmentPrice);
    return {
        amount: groupAdjustmentsTotal + itemAdjustmentsTotal,
        currency
    };
};
exports.calculateFulfillmentGroupAdjustmentsTotal = calculateFulfillmentGroupAdjustmentsTotal;
const handleDecimalSubtraction = (...args) => {
    return (0, lodash_1.map)(args, arg => parseFloat(arg.toFixed(4))).reduce((diff, arg, i) => {
        if (i === 0) {
            return arg;
        }
        return (diff * 10000 - arg * 10000) / 10000;
    }, parseFloat('0.0000'));
};
//# sourceMappingURL=price-utils.js.map